import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter} from "react-router-dom";

import TopNav from "../containers/navs/Topnav";
import Sidebar from "../containers/navs/Sidebar";
class AppLayout extends Component {
  render() {
    const { containerClassnames, history, children, location } = this.props;
    const customMargin = location.pathname.includes("admConversations")
    return (
      <div id="app-container" className={containerClassnames + (customMargin ? " custom-app-container foreground-color" : "")} >
        <TopNav history={history} />
        <Sidebar/>
        <main className={customMargin ? "custom-main" : ""}>
          <div className="container-fluid">
          {children}
          </div>
        </main>
      </div>
    );
  }
}
const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};
const mapActionToProps={}

export default withRouter(connect(
  mapStateToProps,
  mapActionToProps
)(AppLayout));
